// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__n592o","topBottomGutter":"Layout_topBottomGutter__1b1xM"};